export default __webpack_public_path__ + "static/media/tool_twitter.e0e366ea.png";